import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'


import "./css/WorkSpace.css"
import MyNavbar from '../CommonComponents/Navbar'
import EmailVerification from '../CommonComponents/EmailVerification'
import ProjectCreation from '../CommonComponents/ProjectCreation'
import { FetchAllProjectsService } from "../../Services/DjangoServices"
import ProjectLimitExceedModal from "../CommonComponents/ProjectLimitExceedModal"


class WorkSpace extends Component {
        constructor(props) {
                super(props)
                this.state = {
                        email_verified: true,
                        details: {
                                email: null,
                                username: null,
                                first_name: null,
                                log_out: false,
                        },
                        show_project_creation: false,
                        projects: {},
                        show_limit_exceed_modal: false
                }
        }
        logout() {
                window.localStorage.removeItem('auth-token');
                window.location.replace('/');
        }
        componentDidMount() {
                FetchAllProjectsService().then((result) => {
                        result.json().then((data) => {
                                // console.log(data)
                                if ("not_authenticated" in data) {
                                        this.logout();
                                }
                                else {
                                        var email_verified = data["analyst_details"]["email_verified"];
                                        var email = data["analyst_details"]["email"];
                                        var first_name = data["analyst_details"]["first_name"];
                                        var username = data["analyst_details"]["username"]
                                        if (email_verified) {
                                                this.setState({
                                                        email_verified: email_verified,
                                                        details: {
                                                                email: email,
                                                                first_name: first_name,
                                                                username: username
                                                        },
                                                        projects: data["projects"]
                                                });
                                        }
                                        else {
                                                this.setState({
                                                        email_verified: email_verified,
                                                        details: {
                                                                email: email,
                                                                first_name: first_name,
                                                                username: username
                                                        }
                                                });
                                        }
                                }
                        })
                });
        }
        componentWillUnmount() {
                this._isMounted = false;
        }
        showProjectLimmitExceedModal(){
                this.hideProjectCreation()
                this.setState({
                        show_limit_exceed_modal: true
                })
        }
        renderProjects() {
                return Object.keys(this.state.projects).map((key) => {
                        return (
                                <div key={key} className="col-lg-4 col-md-6 col-sm-12 pl-2 pr-2 pt-2 pb-2" align="center">
                                        <div id="create-project-div" align="start" onClick={() => { this.props.history.push("/project/preprocessing/" + key) }}>
                                                <p className="font-weight-bold p-0 m-0" style={{ fontSize: "20px" }}>{this.state.projects[key]["project_name"]}</p>
                                                <p className="text-muted p-0 m-0">last changed: {this.state.projects[key]["last_change_date"].split("T")[0]}</p>
                                                <p className="text-muted p-0 m-0">{this.state.projects[key]["datasets_count"]} datasets</p>
                                                <p className="p-0 m-0" style={{ fontSize: "17px", maxHeight: "50px", overflow: "hidden" }}>{this.state.projects[key]["discription"]}</p>
                                        </div>
                                        <a href={'/settings/' + key}>
                                                <label className="settings_icon">
                                                        <i className="fa fa-cog "></i>
                                                </label>
                                        </a>
                                </div>
                        )
                })
        }
        renderProjectCreation() {
                this.setState({ show_project_creation: true });
        }
        hideProjectCreation() {
                this.setState({ show_project_creation: false });
        }
        render() {
                return (
                        <React.Fragment>
                                <div id="main-project-creation">
                                        <MyNavbar backgroundColor="white" />
                                        {this.state.email_verified ?
                                                <React.Fragment>
                                                        <div id="project-creation-inner">
                                                                <div className="container w-75">
                                                                        <div className="mb-4">
                                                                                <p style={{ fontSize: "20px", fontWeight: "bold" }}>CREATE PROJECT AND UPLOAD THE DATASETS</p>
                                                                                <hr className="bg-primary" style={{ height: "1px" }}></hr>
                                                                        </div>
                                                                        <div className="row">
                                                                                <div className="col-lg-4 col-md-6 col-sm-12 pl-2 pr-2 pt-2 pb-2" align="center">
                                                                                        <div id="create-project-div" align="start" onClick={() => { this.renderProjectCreation() }}>
                                                                                                <label className="m-0 p-0 text-primary" style={{ fontSize: "50px", fontWeight: "bold" }}>+</label>
                                                                                                <h4 className="m-0 p-0">CREATE PROJECT</h4>
                                                                                        </div>
                                                                                </div>
                                                                                {this.renderProjects()}
                                                                        </div>
                                                                </div>
                                                        </div>
                                                        <React.Fragment>
                                                                {this.state.show_project_creation ?
                                                                        <ProjectCreation hideProjectCreation={() => { this.hideProjectCreation() }} showProjectLimmitExceedModal={() => { this.showProjectLimmitExceedModal()}}/>
                                                                        :
                                                                        null
                                                                }
                                                        </React.Fragment>
                                                        <ProjectLimitExceedModal showCondition={this.state.show_limit_exceed_modal}/>
                                                </React.Fragment>
                                                :
                                                <div className="container w-75" style={{ paddingTop: "70px" }}>
                                                        <EmailVerification {...this.state.details} />
                                                </div>
                                        }
                                </div>
                        </React.Fragment>
                )
        }
}


export default withRouter(WorkSpace)